import type {ReactNode} from 'react'

import styles from './ViewOptionsMenu.module.css'

export function DirtyVisual({
  showDirtyIndicator = false,
  children,
}: {
  showDirtyIndicator?: boolean
  children: ReactNode
}) {
  if (!showDirtyIndicator) return children
  return (
    <span className={styles.dirtyVisual}>
      {children}
      <span className={styles.dirtyIndicator} aria-hidden="true" data-testid="view-options-dirty-indicator" />
    </span>
  )
}
